import React from 'react';
import PropTypes from 'prop-types';
import { range, max } from 'lodash';
import moment from 'moment';
import Dialog from '../../../core/layout/Dialog';
import Async from '../../../core/layout/Async';
import BarChart from '../../../core/chart/BarChart';

const KpiDialogHistory = (props) => (
  <Dialog isOpen={props.isOpen} onCancel={props.onCancel} actions={null} width={1000}>
    {props.indicator && (
      <span style={{ fontWeight: 'bold', fontSize: '16px', marginBottom: '20px', display: 'block' }}>
        {props.indicatorFormatter(props.indicator)}
      </span>
    )}
    <Async fetching={props.isLoading}>
      <BarChart
        height={450}
        labels={props.data.map((item) => moment(item.referenceMonth).utc().format('MMM YYYY'))}
        data={props.data.map((item) => item.value)}
        colors={range(0, props.data.length).map(() => 'rgba(47, 64, 80, 0.6)')}
        options={{
          scales: {
            yAxes: [
              {
                ticks: {
                  callback: (label) => {
                    return props.valueFormatter(props.indicator, label);
                  },
                  suggestedMin: 0,
                  suggestedMax: max(props.data.map((item) => item.value)) * 1.2,
                },
              },
            ],
          },
          tooltips: {
            callbacks: {
              label: (tooltipItem, data) => {
                const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                return `${tooltipItem.label}: ${props.valueFormatter(props.indicator, value)}`;
              },
            },
          },
        }}
      />
    </Async>
  </Dialog>
);

KpiDialogHistory.propTypes = {
  isOpen: PropTypes.bool,
  isLoading: PropTypes.bool,
  indicator: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  data: PropTypes.array,
  valueFormatter: PropTypes.func.isRequired,
  indicatorFormatter: PropTypes.func.isRequired,
};
KpiDialogHistory.defaultProps = {
  isOpen: false,
  isLoading: false,
  indicator: '',
  data: [],
};

export default KpiDialogHistory;
